const scannersList = [
  { value: "01", label: "Becca" },
  { value: "02", label: "Angie" },
  { value: "03", label: "Viktoria" },
];

export function getScannerLabel(value) {
  const scannerItem = scannersList.find(item => item.value === value);
  return scannerItem ? scannerItem.label : null;
}

// Export the scanList as well in case you need to access it directly
export { scannersList };